import "./App.css";
import Homepage from "./Components/Homepage/Homepage";
import Landingpage from "./Components/LandingPage/Landingpage";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Course from "./Components/courses/Course";
import CourseDetails from "./Components/courses/coursesdetails/CourseDetails";
import Admin_Dashboard from "./Components/Admin/Admin_Dashboard/Admin_Dashboard";
import Exst_Edu from "./Components/Admin/Exst_Edu/Exst_Edu";
import Exst_Edu_Pro from "./Components/Admin/Exst_Edu_Pro/Exst_Edu_Pro";
import Edu_Validation from "./Components/Admin/Edu_Validation/Edu_Validation";
import Store from './Components/cart/Store'
import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import Feedback from "./Components/feedback/Feedback";
import pic from './Assets/homepage/window.svg'

// import displayRazorpay from './razerpay/razorpay'

function App() {
  const [items, setItems] = useState();
  function addtocart() {
    setItems(...items, Coursedata)
  }
  const Coursedata = {
    img: pic,
    name: "UI/UX course",
    type: "graphic design",
    price: "₹11,495",

  }

  const [auth, setAuth] = useState(null)
  const [time, setTime] = useState(null)

  useEffect(async () => {
    if (Cookies.get('uid')) {
      const user = Cookies.get('uid');
      setAuth(user)
    }
  }, [])
  return (
    <div className="App">
      <Router>
        <Switch>

          <Route exact path="/">
            {
              !auth ?
                <Landingpage /> :
                <Redirect to="/home" />
            }
          </Route>
          <Route exact path="/home">
            <Homepage addtocart={addtocart} />
          </Route>
          <Route exact path="/courses">
            {<Course />}
          </Route>
          <Route path="/coursedetails">
            {<CourseDetails />}
          </Route>
          <Route exact path="/Admin_Dashboard">
            {<Admin_Dashboard />}
          </Route>
          <Route exact path="/Exst_Edu">
            {<Exst_Edu />}
          </Route>
          <Route exact path="/Exst_Edu_Pro">
            {<Exst_Edu_Pro />}
          </Route>
          <Route exact path="/Edu_Validation">
            {<Edu_Validation />}
          </Route>
          <Route exact path="/feedback">
            {<Feedback />}
          </Route>
          <Route exact path="/cart">
            {
              <Store items={items} setItems={setItems} />

            }
          </Route>
        </Switch>
      </Router>

      {/* <Homepage /> */}
      {/* <header className="App-header">
        <p>Buy React now!</p>
        <button className="App-link text-xl text-white border-2" onClick={displayRazorpay}>
          Pay ₹500
        </button>
      </header> */}
    </div>
  );
}

export default App;
